import React from "react";
import "./Choose_Domain.css";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";

const IMG = "/assets/images/spaecialization/";

const domain = [
  { title: "Finance Management", Image: `${IMG}finance.png` },
  { title: "Marketing Management", Image: `${IMG}market_manage.png` },
  { title: "Human Resource Management", Image: `${IMG}human-resource.png` },
  { title: "Operations Management", Image: `${IMG}operations-management.png` },
  { title: "Business Analytics", Image: `${IMG}analytics.png` },
  { title: "Healthcare Management", Image: `${IMG}hostpital.png` },
  { title: "International Business", Image: `${IMG}business-managemnt.png` },
  { title: "IT Management", Image: `${IMG}it.png` },
  { title: "Project Management", Image: `${IMG}project-management.png` },
  { title: "Fintech Management", Image: `${IMG}finetech.png` },
  {
    title: "Artificial Intelligence & Machine Learning Management",
    Image: `${IMG}aiml.png`,
  },
  {
    title: "Logistics Materials & Supply Chain Management",
    Image: `${IMG}logistics.png`,
  },
  { title: "Blockchain Management", Image: `${IMG}blockchain.png` },
  { title: "AgriBusiness Management", Image: `${IMG}agri.png` },
  { title: "Pharmaceutical Management", Image: `${IMG}project-management.png` },
  { title: "Business Executive Management", Image: `${IMG}finetech.png` },
  {
    title: "Travel, Tourism & Hospitality Management",
    Image: `${IMG}finance.png`,
  },
  { title: "And many more...", Image: `${IMG}blockchain.png`, more: true },
];

const Choose_Domain = () => {
  return (
    <section className="Choose_Domain" id="specialization">
      <div className="container">
        <Main_heading_holder
          spanHeading="Specialisations "
          subHeading=" Our online MBA specialisations are crafted with industry leaders to match evolving business demands."
          headingType="h2"
        />

        <ul className="domain_grid">
          {domain.map((item) => (
            <li
              key={item.title}
              className={`domain_card ${item.more ? "domain_card--more" : ""}`}
            >
              <span className="domain_icon">
                <img src={item.Image} alt="" className="item_img" />
              </span>
              <h5 className="item_title">{item.title}</h5>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Choose_Domain;